module.exports = __webpack_public_path__ + "media/components/country-flag/static/uz-5d045e3014b9e4db9a47892686179f7b.svg";